<script>
import { mapState, mapActions } from 'vuex';
import { LAYERS } from '@/constants/gmaps.js';
//https://sarudoli.axiohm.cz/uploads/maps/

export default {
  props: {
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    layer: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      le: null
    };
  },

  //mounted() {
  created() {
    const layerBaseURL = LAYERS.baseUrl + this.layer.phaseId + '/';
    const {
      KmlLayer,
      GroundOverlay,
      LatLngBounds,
      LatLng,
      Data
    } = this.google.maps;

    const gmaps = this.google.maps;

    if (this.layer.type == 'KML') {
      // Load KML
      this.le = new KmlLayer({
        url: layerBaseURL + this.layer.mapUrl100,
        preserveViewport: true,
        map: null
      });
    } else if (this.layer.type == 'SVG') {
      // Load SVG
      let bounds = new LatLngBounds(
        new LatLng(this.layer.svg_LB_lat, this.layer.svg_LB_lng), //levy dolni
        new LatLng(this.layer.svg_RT_lat, this.layer.svg_RT_lng) // pravy horni
      );

      let srcImage = layerBaseURL + this.layer.svgUrl100;

      this.le = new GroundOverlay(srcImage, bounds);
      this.le.setOpacity(1);
    } else if (this.layer.type == 'JSON') {
      // Load JSON
      this.le = new Data();

      this.le.loadGeoJson(layerBaseURL + this.layer.jsonUrl100);

      this.le.setStyle(function (feature) {
        let color = feature.getProperty('fill');
        let label = feature.getProperty('name');

        return {
          fillColor: color,
          strokeWeight: 1,
          strokeColor: color,
          icon: 'http://sarudoli.axiohm.cz/uploads/maps/nopin.png',
          label: label
          //label: {text: label, color: color},
        };
      });
    }

    this.le.addListener('click', (event) => {
      this.$store.dispatch('general/mapClicked', event);
      gmaps.event.trigger(this.map, 'click', event);
    });

    this.$store.dispatch('layers/addGmLayerAndConditionalInit', [
      this.le,
      this.layer.id
    ]);
  },

  computed: {
    ...mapState(['layers']),
    ...mapActions(['layers/addGmLayerAndConditionalInit', 'general/mapClicked'])
  },

  render() {
    return null;
  }
};
</script>
